import styled from 'styled-components'
import parse from 'html-react-parser'

const HtmlContent = (props) => {
  const { content } = props

  return <Body>{parse(content || '')}</Body>
}

const Body = styled.div`
  text-align: left;

  img {
    max-width: 600px;
  }

  ${(p) => p.theme.media.mobile} {
    width: 100%;
    img {
      max-width: 100%;
    }
  }
`

export default HtmlContent
